const isNotEmptyObject = (object) => Object.keys(object).length !== 0;

export default isNotEmptyObject;
